export default __webpack_public_path__ + "../img/d_g550_a_mkt_878.jpg";